export const VIDEO_CATALOG_AMPLITUDE_EVENTS = {
    VIDEO_CATALOGUE_ENTERED: "video_catalogue_entered",
    VIDEO_CHAPTER_SELECTED: "video_chapter_selected",
    VIDEO_CAR_WISHLIST: "video_car_wishlist",
    VIDEO_MUTE: "video_mute",
    VIDEO_VIEW_ALL_DETAILS: "video_view_all_details",
    VIDEO_CAROUSEL_SCROLLED: "video_carousel_scrolled",
    VIDEO_CAROUSEL_SEEN: "video_carousel_seen",
    CHAPTER_CAROUSEL_SCROLLED: "chapter_carousel_scrolled",
    DESKTOP_VIDEO_SNIPPET_SCROLLED: "desktop_video_snippet_scrolled",
    DESKTOP_VIDEO_CHAPTER_SELECTED: "desktop_video_chapter_selected",
    VIDEO_GIF_PREVIEWED: "video_gif_previewed",
    VIDEO_CHECKOUT_INITIATED: "video_checkout_initiated",
    GALLERY_TAB_SELECTED: "gallery_tab_selected",
    CDP_TAB_SELECTED: "cdp_tab_selected",
    VIDEO_TAG_SELECTED: "video_tag_selected",
    CAR_TOUR_TAG_SELECTED: "car_tour_tag_selected",
    VIDEO_CATALOUGE_VARIANT_ASSIGNED: "video_catalogue_variant_assigned",
    GALLERY_PILL_SELECTED: "gallery_pill_selected"
};

export const VIDEO_CATALOG_GA_EVENTS_DESKTOP = {
    CAR_TOUR_TAG_SELECTED: {
        event: "custom_event",
        eventCategory: "Cars24_listing_page",
        eventAction: "filter_video"
    },
    VIDEO_CATALOGUE_ENTERED: {
        event: "video_catalogue_entered",
        eventCategory: "video_catalogue"
    },
    VIDEO_CHAPTER_SELECTED: {
        event: "video_chapter_selected",
        eventCategory: "video_catalogue",
        eventAction: "chapter_name"
    },
    VIDEO_CAR_WISHLIST: {
        event: "video_car_wishlist",
        eventCategory: "video_catalogue"
    },
    VIDEO_MUTE: {
        event: "video_mute",
        eventCategory: "video_catalogue",
        eventAction: "video_mute"
    },
    VIDEO_VIEW_ALL_DETAILS: {
        event: "video_view_all_details",
        eventCategory: "video_catalogue",
        eventAction: "app_id"
    },
    VIDEO_CAROUSEL_SCROLLED: {
        event: "video_caorusel_scrolled",
        eventCategory: "video_catalogue",
        eventAction: "source"
    },
    VIDEO_CAROUSEL_SEEN: {
        event: "video_carousel_seen",
        eventCategory: "video_catalogue",
        eventAction: "source"
    },
    CHAPTER_CAROUSEL_SCROLLED: {
        event: "chapter_carousel_scrolled",
        eventCategory: "video_catalogue"
    },
    DESKTOP_VIDEO_SNIPPET_SCROLLED: {
        event: "desktop_video_snippet_scrolled",
        eventCategory: "video_catalogue",
        eventAction: "desktop_video_snippet_scrolled"
    },
    DESKTOP_VIDEO_CHAPTER_SELECTED: {
        event: "desktop_video_chapter_selected",
        eventCategory: "video_catalogue"
    },
    VIDEO_GIF_PREVIEWED: {
        event: "video_gif_previewed",
        eventCategory: "video_catalogue"
    },
    VIDEO_CHECKOUT_INITIATED: {
        event: "video_checkout_initiated",
        eventCategory: "video_catalogue",
        eventAction: "TD_flow",
        eventLabel: "No"
    },
    GALLERY_TAB_SELECTED: {
        event: "gallery_tab_selected",
        eventCategory: "gallery",
        eventAction: "tab_selected"
    },
    CDP_TAB_SELECTED: {
        event: "cdp_tab_selected",
        eventCategory: "gallery",
        eventAction: "tab_selected"
    },
    VIDEO_TAG_SELECTED: {
        event: "video_tag_selected",
        eventCategory: "video_catalogue",
        eventAction: "app_id"
    },
    VIDEO_CATALOUGE_VARIANT_ASSIGNED: {
        event: "experiment",
        eventCategory: "video_catalogue",
        eventAction: "variant_assigned"
    },
    HIGHLIGHT_TAB_SEEN: {
        event: "highlight_tab_seen",
        eventCategory: "gallery"
    },
    GALLERY_PILL_SELECTED: {
        event: "gallery_pill_selected",
        eventCategory: "gallery"
    }
};
